/**
 * @module tokens
 *
 * All things tokens (of the authentication variety). This is separated into its
 * own module so that other sibling modules can use it side-by-side
 * (e.g., apollo + auth) and avoid circular dependencies.
 */
import { jwt } from '../tools/jwt';
import { appName } from '../config/settings/app.settings';

const ACCESS_TOKEN_KEY = `${appName}/access_token`;
// const REFRESH_TOKEN_KEY = 'refresh_token'; // TODO: implement refresh token pattern
// TODO: revisit file to implement the `adapters/appStorage` pattern

/**
 * Clear all auth tokens from browser.
 */
const clear = () => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);

  return true;
};

/**
 * Get access token from localstorage.
 */
const getAccessToken = () => {
  const token = localStorage.getItem(ACCESS_TOKEN_KEY);
  // If no token is found, or it is expired, it's not really an "error" per se,
  // only there is currently no valid token. User will need to login.
  // @ts-expect-error TS(2345): Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
  if (jwt.isExpired(token)) return null;

  return token;
};

/**
 * Return `true` if access token exists and is not expired.
 */
const hasAccessToken = () => {
  const token = getAccessToken();

  return !!token;
};

/**
 * Write a new access token to localstorage.
 *
 * @param token {string} - new access token (will overwrite existing token)
 */
const saveAccessToken = (token) => {
  localStorage.setItem(ACCESS_TOKEN_KEY, token);

  return true;
};

export { clear, getAccessToken, saveAccessToken, hasAccessToken };
